import { ButtonBadge, ButtonWrapper } from './Button.styles'

const Button = ({ children, block, variant = 'primary', onClick, badge, rounded }) => {
  return (
    <ButtonWrapper block={block} variant={variant} rounded={rounded} onClick={onClick}>
      {children}
      {badge && <ButtonBadge>{badge}</ButtonBadge>}
    </ButtonWrapper>
  )
}

export default Button
